import Axios from 'axios';
import { Config } from '../apiRoutes';

import {
  SHOP_FIND_OR_CREATE_REQUESTED,
  SHOP_FIND_OR_CREATE_SUCCESS,
  SHOP_FIND_OR_CREATE_FAILURE,
  SHOP_SETTINGS_FIND_REQUESTED,
  SHOP_SETTINGS_FIND_SUCCESS,
  SHOP_SETTINGS_FIND_FAILURE,
  SHOPIFY_SETTINGS_FIND_REQUESTED,
  SHOPIFY_SETTINGS_FIND_SUCCESS,
  SHOPIFY_SETTINGS_FIND_FAILURE,
} from '../types';

export const findOrCreateRequested = () => {
  return {
    type: SHOP_FIND_OR_CREATE_REQUESTED
  }
};

export const findOrCreateSuccess = (shop) => {
  return {
    type: SHOP_FIND_OR_CREATE_SUCCESS,
    payload: shop
  }
};

export const findOrCreateFailure = (error) => {
  return {
    type: SHOP_FIND_OR_CREATE_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};


export const findSettingsRequested = () => {
  return {
    type: SHOP_SETTINGS_FIND_REQUESTED
  }
};

export const findSettingsSuccess = (shopSettings) => {
  return {
    type: SHOP_SETTINGS_FIND_SUCCESS,
    payload: shopSettings
  }
};

export const findSettingsFailure = (error) => {
  return {
    type: SHOP_SETTINGS_FIND_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const shopSettingsRequested = () => {
  return {
    type: SHOPIFY_SETTINGS_FIND_REQUESTED
  }
};

export const shopSettingsSuccess = (settings) => {
  return {
    type: SHOPIFY_SETTINGS_FIND_SUCCESS,
    payload: settings
  }
};

export const shopSettingsFailure = (error) => {
  return {
    type: SHOPIFY_SETTINGS_FIND_FAILURE,
    status: error.response?.status,
    message: error.message,
  }
};

export const findOrCreate = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(findOrCreateRequested());

    let endPoint = Config.baseUrl + Config.shop;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(findOrCreateSuccess(response.data));
      })
      .catch((error) => {
        dispatch(findOrCreateFailure(error));
      })
  }
}

export const findSettings = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(findSettingsRequested());

    let endPoint = Config.baseUrl + Config.shop + Config.settings;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.post(endPoint, {}, { headers: headers })
      .then((response) => {
        dispatch(findSettingsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(findSettingsFailure(error));
      })

  }
}

export const shopSettings = (shopUrl, payload) => {
  return (dispatch) => {
    dispatch(shopSettingsRequested());

    let endPoint = Config.baseUrl + Config.shop + Config.shopifySettings;
    let headers = Object.assign(Config.headers);
    headers.payload = payload;
    headers.shop = shopUrl;

    return Axios.get(endPoint, { headers: headers })
      .then((response) => {
        dispatch(shopSettingsSuccess(response.data));
      })
      .catch((error) => {
        dispatch(shopSettingsFailure(error));
      })

  }
}
